import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";

function Dropdown({ title, dropdownMenu }) {
  const location = useLocation();

  return (
    <Navbar style={{ boxShadow: "none", padding: "5px" }}>
      <Navbar.Toggle aria-controls="navbar-dark-example" />
      <Navbar.Collapse id="navbar-dark-example">
        <Nav>
          <NavDropdown
            id="nav-dropdown-dark-example"
            title={
              <span
                style={{
                  color: "rgb(104, 104, 104, 1)",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {title}
              </span>
            }
          >
            {dropdownMenu?.length > 0 &&
              dropdownMenu.map((item, index) => (
                <NavDropdown.Item
                  key={index}
                  as={Link}
                  to={item.path}
                  active={location.pathname === item.path}
                >
                  {item.title}
                </NavDropdown.Item>
              ))}
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Dropdown;
